"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdgeGradient = exports.WrapperStyled = exports.WrapperWithEdgeGradientsStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.WrapperWithEdgeGradientsStyled = styled_components_1.default.div `
    display: flex;
    overflow: auto;
    position: relative;
    gap: ${({ gap }) => gap};
    align-items: center;
`;
exports.WrapperStyled = styled_components_1.default.div `
    z-index: 100;
    position: relative;
    background-color: ${({ colorStart }) => colorStart};
    width: 100%;
    padding: 0 10px;
`;
exports.EdgeGradient = styled_components_1.default.div `
    position: absolute;
    bottom: 0;
    ${({ side }) => (side === 'right' ? 'right: 0' : 'left: 0')};
    width: 32px;
    height: 100%;
    pointer-events: none;
    z-index: 1;
    background: linear-gradient(
        ${({ side }) => (side === 'right' ? '270deg' : '90deg')},
        ${({ colorStart }) => colorStart} 37.78%,
        ${({ colorEnd }) => colorEnd} 100%
    );
`;
